module.exports = __webpack_public_path__ + "static/img/voice5_left.2c3ae046.png";